<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">C<span class="small">ONTENTS</span></p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc"><a href="#/Introduction">Introduction</a></p>
<p class="toc1"><a href="#/Part1#P1">P<span class="small">ART</span> I: T<span class="small">HE</span> H<span class="small">ISTORY OF THE</span> K<span class="small">ANCAMAGUS</span> R<span class="small">OUTE</span></a></p>
<p class="toc"><a href="#/Chapter1#C1">1. The Native American Presence</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. The Settling of Conway, Albany and the Swift River Intervale</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. The Logging Railroads Stake Their Claim</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The Beginnings of the White Mountain National Forest and the Kancamagus Highway</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. The Completion of the Kancamagus Highway and the Influence of Loon Mountain</span></p>
<p class="toc1"><span href="#/Part2#P2" title="Link target outside of Sample">P<span class="small">ART</span> II: A G<span class="small">UIDE TO</span> D<span class="small">RIVING THE</span> K<span class="small">ANCAMAGUS</span> H<span class="small">IGHWAY</span></span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Scenic Attractions along the Kanc</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Trees and Wildlife along the Kanc</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. Camping along the Kanc</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Hiking along the Kanc</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. More to Know Before You Go</span></p>
<p class="toc1"><span href="#/Source_Bibliography" title="Link target outside of Sample">Source Bibliography and Further Reading</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?62f6c7ac